module.exports = __webpack_public_path__ + "static/media/searching.76455d4a.png";